import classNames from "classnames";
import { ReactNode } from "react";

import styles from "./FilterSection.module.scss";

interface FilterSectionProps {
  children?: ReactNode;
  title?: string;
  afterTitle?: ReactNode;
  count?: number;
  className?: string;
}

const FilterSection = ({
  children,
  className,
  title,
  afterTitle,
  count = 0,
}: FilterSectionProps) => {
  if (!children) return null;

  return (
    <section className={classNames(styles.section, className)}>
      {title && (
        <div
          className={classNames(styles.title, {
            [styles.bold]: count > 0,
          })}
        >
          <span>
            {title}
            {count > 0 && ` (${count})`}
          </span>
          {afterTitle}
        </div>
      )}
      <div className={styles.grid}>{children}</div>
    </section>
  );
};

export default FilterSection;
